(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["neuaura-welcome"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('neuaura-welcome')) {
    customElements.define('neuaura-welcome', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.dialog = this.querySelector('dialog');
        this.tab = this.querySelector('.na-welcome-tab');
        this.canvas = this.querySelector('canvas');
        this.key = 'neuaura-welcome-10-v1';
        this.revealed = false;
        this.querySelector('.na-welcome-close').addEventListener('click', () => this.dialog.close());
        this.querySelector('.na-welcome-reveal').addEventListener('click', () => this.reveal());
        this.querySelector('.na-welcome-apply').addEventListener('click', () => this.store('claimed'));
        this.tab.addEventListener('click', () => this.open());
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('na-welcome-open');
          this.store(this.revealed ? 'revealed' : 'dismissed');
          this.tab.hidden = false;
          if (this.previousFocus instanceof HTMLElement && this.previousFocus !== document.body) this.previousFocus.focus();
          else this.tab.focus();
        });
        this.dialog.addEventListener('click', (event) => {
          const r = this.dialog.getBoundingClientRect();
          if (event.target === this.dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) this.dialog.close();
        });
        this.canvas.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'mouse' && event.button !== 0) return;
          this.canvas.setPointerCapture(event.pointerId);
          this.drawing = true;
          this.lastPoint = null;
          this.scratch(event);
        });
        this.canvas.addEventListener('pointermove', (event) => { if (this.drawing) this.scratch(event); });
        const finish = () => { this.drawing = false; this.lastPoint = null; this.checkReveal(); };
        this.canvas.addEventListener('pointerup', finish);
        this.canvas.addEventListener('pointercancel', finish);
        this.canvas.addEventListener('lostpointercapture', finish);
        this.observer = new ResizeObserver(() => { if (this.dialog.open && !this.revealed) this.paint(); });
        this.observer.observe(this.canvas);
        let seen;
        try { seen = sessionStorage.getItem(this.key); } catch {}
        if (seen === 'revealed' || seen === 'claimed') this.reveal(false);
        this.tab.hidden = false;
        if (!seen && !window.Shopify?.designMode) {
          if (document.readyState === 'complete') this.open();
          else window.addEventListener('load', () => this.open(), { once: true });
        }
      }
      store(value) { try { sessionStorage.setItem(this.key, value); } catch {} }
      open() {
        if (!this.isConnected || this.dialog.open) return;
        if (document.querySelector('dialog[open]')) return;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        document.documentElement.classList.add('na-welcome-open');
        this.tab.hidden = true;
        this.store(this.revealed ? 'revealed' : 'seen');
        if (!this.revealed) this.paint();
      }
      paint() {
        const rect = this.canvas.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        this.canvas.width = Math.round(rect.width);
        this.canvas.height = Math.round(rect.height);
        this.ctx = this.canvas.getContext('2d', { willReadFrequently: true });
        if (!this.ctx) { this.reveal(false); return; }
        const ctx = this.ctx;
        const gradient = ctx.createLinearGradient(0, 0, rect.width, rect.height);
        gradient.addColorStop(0, '#4877e9'); gradient.addColorStop(1, '#9154cc');
        ctx.globalCompositeOperation = 'source-over';
        ctx.fillStyle = gradient; ctx.fillRect(0, 0, rect.width, rect.height);
        ctx.strokeStyle = '#ffffff20'; ctx.lineWidth = 1;
        for (let x = -rect.height; x < rect.width; x += 22) {
          ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x + rect.height, rect.height); ctx.stroke();
        }
        ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
        ctx.font = '600 18px sans-serif'; ctx.fillStyle = '#ffffff';
        ctx.fillText(this.dataset.scratchLabel, rect.width / 2, rect.height / 2);
        this.drawing = false; this.lastPoint = null;
      }
      scratch(event) {
        if (this.revealed || !this.ctx) return;
        const r = this.canvas.getBoundingClientRect();
        const point = { x: (event.clientX - r.left) * this.canvas.width / r.width, y: (event.clientY - r.top) * this.canvas.height / r.height };
        const ctx = this.ctx;
        ctx.globalCompositeOperation = 'destination-out';
        ctx.lineWidth = 44; ctx.lineCap = 'round'; ctx.lineJoin = 'round';
        ctx.beginPath(); ctx.moveTo(this.lastPoint?.x ?? point.x, this.lastPoint?.y ?? point.y);
        ctx.lineTo(point.x, point.y); ctx.stroke();
        ctx.beginPath(); ctx.arc(point.x, point.y, 22, 0, Math.PI * 2); ctx.fill();
        this.lastPoint = point;
        if (performance.now() - (this.lastCheck || 0) > 160) { this.lastCheck = performance.now(); this.checkReveal(); }
      }
      checkReveal() {
        if (!this.ctx || this.revealed) return;
        const { width, height } = this.canvas;
        const pixels = this.ctx.getImageData(0, 0, width, height).data;
        let cleared = 0; let total = 0;
        for (let y = 4; y < height; y += 8) for (let x = 4; x < width; x += 8) { total++; if (pixels[(y * width + x) * 4 + 3] < 100) cleared++; }
        if (total && cleared / total >= .32) this.reveal();
      }
      reveal(moveFocus = true) {
        this.revealed = true;
        this.drawing = false;
        this.canvas.hidden = true;
        this.querySelector('.na-welcome-reward').removeAttribute('aria-hidden');
        this.querySelector('.na-welcome-before').hidden = true;
        this.querySelector('.na-welcome-after').hidden = false;
        this.store('revealed');
        if (moveFocus && this.dialog.open) this.querySelector('.na-welcome-apply').focus();
      }
      disconnectedCallback() { this.observer?.disconnect(); document.documentElement.classList.remove('na-welcome-open'); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
